import { render, staticRenderFns } from "./multipleChoice.vue?vue&type=template&id=245ea9d4"
import script from "./multipleChoice.vue?vue&type=script&lang=js"
export * from "./multipleChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245ea9d4')) {
      api.createRecord('245ea9d4', component.options)
    } else {
      api.reload('245ea9d4', component.options)
    }
    module.hot.accept("./multipleChoice.vue?vue&type=template&id=245ea9d4", function () {
      api.rerender('245ea9d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionnaire/customerManage/questionnaireList/components/multipleChoice.vue"
export default component.exports